import React from 'react'
import { useFilters } from '../../context/FiltersContext'
import { Filter } from './Filter'
import { Clearfix } from '../Clearfix'
import {
  SampleColoursBlock,
  SampleColoursBlockTitle,
  SampleColoursBlockBlocks,
} from '../Layout'

interface Props {
  topFilter: string
}

export const ColourFilters: React.FC<Props> = ({ topFilter }) => {
  const { filters } = useFilters()

  const colours = filters.colour[topFilter]
  const coloursArr = Object.keys(colours).map(colour => colours[colour])

  return (
    <SampleColoursBlock>
      <SampleColoursBlockTitle>{topFilter}</SampleColoursBlockTitle>
      <SampleColoursBlockBlocks>
        {coloursArr.map(colour => (
          <Filter key={colour.id} filter={colour} />
        ))}
        <Clearfix />
      </SampleColoursBlockBlocks>
    </SampleColoursBlock>
  )
}
